import React from 'react';
import Loader from 'react-simple-loading';


function TrasparentLoader() {
  return (
    <div
      style={{
        position: 'fixed',
        height: '100vh',
        width: '100vw',
        backgroundColor: 'rgb(255, 255, 255, 0.5)',
        top: 0,
        zIndex: 1000,
      }}
    >
      <Loader />
    </div>
  );
}

export default React.memo(TrasparentLoader);
